import React from 'react';
import { DataGrid as MuiDataGrid, type GridColDef, type GridRowsProp } from '@mui/x-data-grid';
import { Box } from '@mui/material';

export interface DataGridProps {
  columns: GridColDef[];
  rows: GridRowsProp;
  loading?: boolean;
  pageSize?: number;
  height?: number;
  onEdit?: (id: string | number) => void;
  onRowClick?: (params: any) => void;
  getRowId?: (row: any) => string | number;
  pagination?: boolean;
}

const DataGrid: React.FC<DataGridProps> = ({
  columns,
  rows,
  loading = false,
  pageSize = 10,
  height = 550,
  onRowClick,
  getRowId,
  pagination = true,
}) => {
  return (
    <Box
      sx={{
        height,
        width: '100%',
        borderRadius: 3,
        overflow: 'hidden',
        border: '1px solid #e2e8f0',
        backgroundColor: '#fff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
      }}
    >
      <MuiDataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        getRowId={getRowId}
        onRowClick={onRowClick}
        hideFooter={!pagination}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize },
          },
        }}
        pageSizeOptions={pagination ? [5, 10, 25] : []}
        disableRowSelectionOnClick
        rowHeight={48}
        columnHeaderHeight={44}
        slotProps={{
          pagination: {
            labelRowsPerPage: 'Filas por pagina',
          },
        }}
        sx={{
          border: 'none',
          fontFamily: '"DM Sans", sans-serif',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#f8fafc',
            borderBottom: '2px solid #e2e8f0',
          },
          '& .MuiDataGrid-columnHeader': {
            borderLeft: 'none',
            borderRight: 'none',
            borderTop: 'none',
            padding: '8px 16px',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontFamily: '"DM Sans", sans-serif',
            fontWeight: 700,
            fontSize: '0.7rem',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            color: '#64748b',
          },
          '& .MuiDataGrid-row': {
            transition: 'background-color 0.15s ease',
            '&:hover': {
              backgroundColor: '#f0f7ff',
              cursor: onRowClick ? 'pointer' : 'default',
            },
          },
          '& .MuiDataGrid-cell': {
            borderLeft: 'none',
            borderRight: 'none',
            borderTop: 'none',
            borderBottom: '1px solid #f1f5f9',
            padding: '6px 16px',
            fontSize: '0.85rem',
            lineHeight: 1.5,
            fontWeight: 400,
            color: '#1e293b',
          },
          '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnSeparator': {
            visibility: 'hidden',
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: '2px solid #e2e8f0',
            backgroundColor: '#f8fafc',
          },
          '& .MuiTablePagination-root': {
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '0.8rem',
            color: '#64748b',
          },
        }}
      />
    </Box>
  );
};

export default DataGrid;
